// extracted by mini-css-extract-plugin
module.exports = {"nav":"DigitalTwinNavigation_nav__3GY1F","link":"DigitalTwinNavigation_link__2S5KH","linkActive":"DigitalTwinNavigation_linkActive__1lSJC"};